import { useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import "./Content.css";
import {
  faPen,
  faTrash,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { baseURL } from "../../../API/API";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function CombosDashboard() {
  const [combos, setCombos] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [showmessage, setShowMessage] = useState(false);
  const [rowId, setrowId] = useState(null);
  const [indexpage, setindexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosPrivate.get(`${baseURL}/learning/combos/all-admin?indexpage=${indexpage}`);
      setCombos(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      console.error(err);
      toast.error("فشل تحميل الباقات");
    } finally {
      setLoading(false);
    }
  }, [indexpage, axiosPrivate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async () => {
    try {
      await axiosPrivate.delete(`${baseURL}/learning/combos/delete/${rowId}`);
      toast.success("تم حذف الباقة بنجاح");
      setShowMessage(false);
      fetchData();
    } catch (err) {
      console.error(err);
      toast.error("فشل حذف الباقة");
    }
  };

  return (
    <div className="p-4 content" dir="rtl">
      <div className="d-flex align-items-center justify-content-between mb-5">
        <h4 className="fw-bold m-0">باقات الكورسات (الكومبو)</h4>
        <Link to="/DashboardLayout/combos/add">
          <Button className="custom-brand-btn-dhash flex-center-both gap-2 px-4">
            <FontAwesomeIcon icon={faPlus} />
            <span>إضافة باقة جديدة</span>
          </Button>
        </Link>
      </div>

      <div className="table-responsive">
        {loading ? (
          <div className="text-center py-5 text-muted">جاري التحميل...</div>
        ) : combos.length === 0 ? (
          <div className="text-center py-5 text-muted">لا توجد باقات كومبو حالياً.</div>
        ) : (
          <Table striped bordered hover className="align-middle text-center">
            <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
              <tr>
                <th>الاسم</th>
                <th>الوصف</th>
                <th>السعر</th>
                <th>الخصم</th>
                <th>فودافون كاش</th>
                <th>انستا باي</th>
                <th>عدد الكورسات المشمولة</th>
                <th>الحالة</th>
                <th>أدوات</th>
              </tr>
            </thead>
            <tbody>
              {combos.map((row) => (
                <tr key={row.id}>
                  <td className="fw-bold">{row.name}</td>
                  <td className="text-truncate" style={{ maxWidth: "200px" }}>{row.description || "لا يوجد"}</td>
                  <td>{row.price} ج.م</td>
                  <td>{row.discount} ج.م</td>
                  <td>{row.vodafone_cash || "الافتراضي"}</td>
                  <td>{row.instapay || "الافتراضي"}</td>
                  <td>
                    <span className="badge bg-purple-light text-purple">
                      {row.chapters_count} وحدات
                    </span>
                  </td>
                  <td>
                    {row.is_draft ? (
                      <span className="badge bg-warning-light text-warning">مسودة</span>
                    ) : (
                      <span className="badge bg-success-light text-success">منشورة</span>
                    )}
                  </td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <Link to={`/DashboardLayout/combos/update/${row.id}`}>
                        <OverlayTrigger placement="top" overlay={<Tooltip>تعديل</Tooltip>}>
                          <Button size="sm" variant="outline-info">
                            <FontAwesomeIcon icon={faPen} style={{ color: "#17A2B8" }} />
                          </Button>
                        </OverlayTrigger>
                      </Link>

                      <OverlayTrigger placement="top" overlay={<Tooltip>حذف</Tooltip>}>
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() => {
                            setrowId(row.id);
                            setShowMessage(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </OverlayTrigger>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4" dir="ltr">
          <Pagination>
            <Pagination.Prev disabled={indexpage === 1} onClick={() => setindexPage(prev => prev - 1)} />
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item key={i + 1} active={i + 1 === indexpage} onClick={() => setindexPage(i + 1)}>
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next disabled={indexpage === totalPages} onClick={() => setindexPage(prev => prev + 1)} />
          </Pagination>
        </div>
      )}

      {/* Confirm Delete Modal */}
      <Modal show={showmessage} onHide={() => setShowMessage(false)} centered>
        <Modal.Body className="text-center py-4">
          <p className="fs-5 fw-bold mb-4">هل أنت متأكد من رغبتك في حذف هذه الباقة؟</p>
          <div className="d-flex justify-content-center gap-3">
            <Button variant="danger" className="px-4" onClick={handleDelete}>نعم، احذف</Button>
            <Button variant="secondary" className="px-4" onClick={() => setShowMessage(false)}>إلغاء</Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
